<template>
  <div>
    <PageTitle title="Create User" :backBtn="true" :showLoading="isLoading" />

    <v-container fluid class="lighten-12 content">
      <v-row>
        <v-col cols="12" sm="12" md="8" lg="8">
          <ValidationObserver ref="observer">
            <v-card class="lighten-12 card-content mb-1">
              <!-- <v-overlay v-if="isLoading"></v-overlay> -->

              <!-- <v-progress-linear
              active="false"
              indeterminate="false"
              :query="false"
              v-if="isLoading"
            ></v-progress-linear> -->
              <v-card-title> General</v-card-title>
              <!-- Stack the columns on mobile by making one full-width and the other half-width -->
              <v-container fluid class="light gray lighten-12">
                <form>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Email"
                        vid="email"
                        rules="required|email"
                      >
                        <v-text-field
                          outlined
                          dense
                          hide-details="auto"
                          v-model="user.email"
                          :error-messages="errors"
                          label="E-mail"
                          required
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Username"
                        vid="username"
                        rules="required"
                      >
                        <v-text-field
                          hide-details="auto"
                          outlined
                          dense
                          v-model="user.username"
                          :error-messages="errors"
                          label="UserName"
                          required
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Roles"
                        vid="roles"
                        rules="required"
                      >
                        <v-select
                          hide-details="auto"
                          dense
                          v-model="user.roles"
                          item-text="name"
                          item-value="id"
                          :items="roles"
                          :error-messages="errors"
                          label="Roles"
                          outlined
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="KOT Access Type"
                        rules="required"
                      >
                        <v-select
                          hide-details="auto"
                          dense
                          multiple
                          chips
                          small-chips
                          deletable-chips
                          v-model="user.kot_access_types"
                          :items="userTypeOptions"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors"
                          label="KOT Access Type"
                          outlined
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Phone"
                        vid="phone"
                        :rules="{
                          required: true,
                          regex: /^[A-Za-z0-9+]{1,15}$/,
                        }"
                      >
                        <v-text-field
                          dense
                          outlined
                          hide-details="auto"
                          v-model="user.contact.phone"
                          :error-messages="errors"
                          label="Phone number"
                          maxlength="15"
                          required
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </form>
              </v-container>
            </v-card>
          </ValidationObserver>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <v-row>
            <v-col cols="12">
              <v-card class="lighten-12">
                <v-container class="light gray lighten-12">
                  <v-row>
                    <v-col cols="12 py-0">
                      <v-flex class="pt-0 pa-1">
                        <FileUpload
                          title="Image"
                          :multiple="false"
                          v-model="selectedImages"
                          :size="10000"
                          :types="['jpeg', 'png', 'jpg']"
                          :showPreview="true"
                          :camera="true"
                          @isImageUpdated="imageUpdated = $event"
                        />
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Submit -->
      <!-- <v-col offset="9">
        <v-btn
          depressed
          small
          class="text-white btn_blue btn_medium w-100"
          :disabled="isSubmitDisabled"
          @click="submit"
          >submit</v-btn
        >
        <v-btn depressed small @click="clear" class="ml-1 text-white btn_medium"
          >clear</v-btn
        >
      </v-col> -->
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn @click="clear" depressed small class="ml-1 text-white btn_medium"
          >clear</v-btn
        >
        <v-btn
          @click="submit"
          depressed
          small
          class="text-white btn_blue btn_medium w-100"
          :disabled="isLoading || isSubmitDisabled"
          >submit</v-btn
        >
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import { required, email, max, regex } from 'vee-validate/dist/rules';
import { User } from '../../../models/User';
import { UserEntityModel } from '../../../models/EntityModels/UserEnitityModel';
import FileUpload from '@/components/base/FileUpload';
import ServerMessages from '@/components/shared/ServerMessages';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('no_spaces_only', {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: '{_field_} cannot be empty or spaces only',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid phone number',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    ServerMessages,
  },

  data: () => ({
    isLoading: false,
    isSubmitDisabled: false,
    name: '',
    email: '',
    select: null,
    roles: [],
    items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
    checkbox: null,
    user: {
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      roles: [],
      usertype: 1,
      kot_access_types: [1],
      waiter_id: null,
      address: {},
      contact: { telephone: '', phone: '' },
    },
    userTypeOptions: [
      { label: 'KOT', value: 1 },
      { label: 'Kitchen', value: 2 },
      { label: 'Waiter', value: 3 },
    ],
    errors: [],
    messages: [],
    selectedImages: null,
    imageUpdated: false,
    countries: [],
    ServerError: '',
  }),

  methods: {
    async submit() {
      if (this.isLoading || this.isSubmitDisabled) {
        return;
      }
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        await this.RegisterUser();
      }
    },
    extractUserId(res) {
      const data = res && res.data;
      if (!data || typeof data !== 'object') {
        return null;
      }
      if (data.id != null) {
        return data.id;
      }
      if (data.data && data.data.id != null) {
        return data.data.id;
      }
      return null;
    },
    hasSelectedImage() {
      if (!this.imageUpdated || !this.selectedImages) {
        return false;
      }
      if (this.selectedImages instanceof File) {
        return true;
      }
      return (
        Array.isArray(this.selectedImages) &&
        this.selectedImages.length > 0 &&
        this.selectedImages[0] instanceof File
      );
    },
    getSelectedImageFile() {
      if (this.selectedImages instanceof File) {
        return this.selectedImages;
      }
      if (
        Array.isArray(this.selectedImages) &&
        this.selectedImages[0] instanceof File
      ) {
        return this.selectedImages[0];
      }
      return null;
    },
    async UploadUserImage(userId) {
      const file = this.getSelectedImageFile();
      if (!file) {
        return;
      }
      const fromData = new FormData();
      fromData.append('image', file);
      fromData.append('id', userId);
      return await this.$store.dispatch(`user/UploadUserImage`, fromData);
    },

    clear() {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        roles: [],
        usertype: 1,
        kot_access_types: [1],
        waiter_id: null,
        address: {},
        contact: { telephone: '', phone: '' },
      };
      this.selectedImages = null;
      this.imageUpdated = false;
      this.$refs.observer.reset();
    },
    async RegisterUser() {
      this.isLoading = true;
      this.isSubmitDisabled = true;
      this.messages = [];
      try {
        const res = await this.$store.dispatch(
          'user/RegisterUser',
          new UserEntityModel(this.user),
        );
        await this.handleRegisterSuccess(res);
      } catch (err) {
        this.handleRegisterError(err);
      }
    },
    async handleRegisterSuccess(res) {
      const userId = this.extractUserId(res);
      const credentialUrl =
        res && res.data && typeof res.data === 'object'
          ? res.data.credential
          : null;

      try {
        if (!userId) {
          this.$toast.error(
            'Unexpected server response. Please check the Users list.',
          );
          this.$router.push({ path: '/user' });
          return;
        }

        if (this.hasSelectedImage()) {
          try {
            await Promise.race([
              this.UploadUserImage(userId),
              new Promise((_, reject) =>
                setTimeout(() => reject(new Error('upload timeout')), 30000),
              ),
            ]);
          } catch (uploadErr) {
            this.$toast.warning(
              'User created successfully, but the profile image could not be uploaded.',
            );
          }
        }

        const emailSent = res && res.data && res.data.email_status === true;

        if (emailSent) {
          this.$toast.success(
            'User registered successfully. Login credentials were sent by email.',
          );
        } else {
          this.$toast.warning(
            'User registered successfully, but the credentials email could not be sent. Share the password manually or use the downloaded credential file.',
          );
        }

        if (credentialUrl && !emailSent) {
          setTimeout(() => {
            window.open(credentialUrl, '_blank');
          }, 0);
        }

        this.$router.push({ path: '/user' });
      } catch (err) {
        this.$toast.error('User created, but something went wrong afterward.');
        this.$router.push({ path: '/user' });
      } finally {
        this.isLoading = false;
        this.isSubmitDisabled = false;
      }
    },
    handleRegisterError(err) {
      this.ServerError = err;
      this.isSubmitDisabled = false;
      this.isLoading = false;

      const status = err && err.status;
      const payload =
        err && err.data && typeof err.data === 'object' ? err.data : {};
      const message =
        payload.message ||
        (typeof err.data === 'string' ? err.data : null) ||
        'Registration failed';

      if ([502, 503, 504].includes(status)) {
        this.$toast.warning(
          'The request timed out. The user may already have been created — check the Users list before submitting again.',
        );
        return;
      }

      const errors = payload.error;
      if (errors && typeof errors === 'object') {
        const fieldErrors = {};
        Object.keys(errors).forEach((key) => {
          const vid = key.includes('.') ? key.split('.').pop() : key;
          fieldErrors[vid] = errors[key];
        });
        this.$refs.observer.setErrors(fieldErrors);
        this.$toast.error(Object.values(errors)[0] || message);
        return;
      }

      this.$toast.error(message);
    },

    GetRoles() {
      this.$store
        .dispatch('GetRoles')
        .then((res) => {
          this.roles = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetRoles();
  },
};
</script>

<style scoped>
/* .btnRightMargin {
  margin-right: 10px;
}

.container {
  color: white !important;
}
.form-blue {
  background: #d8dbe0;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.messages {
  border: transparent !important;
  margin-right: 40px;
} */
</style>
